import { render, staticRenderFns } from "./DetailTickets.vue?vue&type=template&id=5a49a1a2"
import script from "./DetailTickets.vue?vue&type=script&lang=ts"
export * from "./DetailTickets.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports